/**
 * notification-seen-store — cihaz-bazlı "toast görüldü" izleyici (N2-03, D-T2)
 *
 * Toast bombardımanını engeller: bir bildirim için bu cihazda toast bir kez
 * gösterildiğinde id'si localStorage'a yazılır ve tekrar toast atılmaz. Saf,
 * React'sız modül (kolay test). BACKEND DEĞİŞMEZ — okundu durumu backend'de,
 * bu yalnız istemci-yerel kozmetik toast zamanlamasıdır (T-N2-06 accept).
 *
 * SSR/quota/bozuk-JSON güvenli: her erişim try/catch ile sarılır, hata halinde
 * boş küme gibi davranır (çökme yok). FIFO cap CAP=200 — en eski görülmüşler
 * düşer, sınırsız büyüme yok.
 */
const STORAGE_KEY = 'sensei:notif:seenToastIds'
const CAP = 200

/** localStorage'dan güvenli oku → string[] (bozuk/eksik → []). */
function _read(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((x): x is string => typeof x === 'string')
  } catch {
    // SSR (localStorage yok) / erişim hatası → boş küme
    return []
  }
}

/** localStorage'a güvenli yaz — son CAP kaydı tutulur (FIFO); hata yutulur. */
function _write(ids: string[]): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids.slice(-CAP)))
  } catch {
    // quota aşımı / SSR → sessizce yut
  }
}

/** Bu id için cihazda daha önce toast gösterildi mi? */
export function hasSeen(id: string): boolean {
  return _read().includes(id)
}

/** Tek id'yi görülmüş işaretle (idempotent). */
export function addSeen(id: string): void {
  const ids = _read()
  if (ids.includes(id)) return
  _write([...ids, id])
}

/** Birden çok id'yi tek yazma ile görülmüş işaretle (flood senaryosu). */
export function addManySeen(newIds: string[]): void {
  if (newIds.length === 0) return
  const ids = _read()
  const set = new Set(ids)
  let changed = false
  for (const id of newIds) {
    if (!set.has(id)) {
      ids.push(id)
      set.add(id)
      changed = true
    }
  }
  if (changed) _write(ids)
}

/** Yalnız test için — depoyu temizle. */
export function __resetSeenStore(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // yut
  }
}
